export default "__VITE_ASSET__ZdeIcj2I__"